<template>
  <h1 class="mt-5 font-weight-bold text-primary">MoreInfo page</h1>
</template>

<script>
export default {
  name: 'MoreInfoPage'
};
</script>
